import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

export const CompanyDetails = () => {
  const { t } = useLanguage();
  const r = t.reg;

  return (
    <section className="relative py-20 lg:py-24 bg-[#F8FBF8]" data-testid="company-details">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="border border-[rgba(20,112,63,0.16)] rounded-sm bg-white p-8 lg:p-12"
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-4 flex flex-col items-center lg:items-start">
              <img
                src="/logo-full.png"
                alt="Aaravya Impex Private Limited logo"
                className="w-56 lg:w-64 object-contain"
                data-testid="company-logo-full"
              />
              <div className="font-mono-spec text-[10px] tracking-[0.3em] uppercase text-[#B8912F] mt-4" data-testid="company-motto">
                {r.motto}
              </div>
            </div>

            <div className="lg:col-span-8">
              <span className="eyebrow-label">{r.eyebrow}</span>
              <h2 className="font-serif-display text-3xl sm:text-4xl tracking-tight mt-3 text-[#12261A]" data-testid="company-reg-title">
                {r.title}
              </h2>
              <div className="mt-5 text-sm text-[#51685A]" data-testid="company-address">
                <span className="font-mono-spec text-[9px] tracking-[0.22em] uppercase text-[#8CA594] block mb-1">{r.addressLabel}</span>
                {r.address}
              </div>

              <div className="mt-7 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-4" data-testid="company-reg-grid">
                {r.items.map((item) => (
                  <div key={item.k} className="border-t border-[rgba(20,112,63,0.12)] pt-3">
                    <div className="font-mono-spec text-[9px] tracking-[0.22em] uppercase text-[#8CA594]">{item.k}</div>
                    <div className="font-mono-spec text-xs sm:text-sm text-[#12261A] mt-1">{item.v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
